// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1227":"01be5c61","4274":"70ee90c6","8513":"95728fd4"}[chunkId] + ".chunk.css";
};